import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
} from "@websential/cosmic-v20";

import { Grid } from "@mui/material";
import React from "react";

interface IEmployeeSetupReportHeader {
	employeeReportSetupDDlItems?: { label: string; value: any }[];
	employeeBasedProvinceOfEmployementDDL?: { label: string; value: any }[];
	setStateRunGetListAPICall: (value: boolean) => void
	// onApplyButtonClickedHandler: () => void;
}

export const EmployeeSetupReportHeader: React.FC<
	IEmployeeSetupReportHeader
> = ({ employeeReportSetupDDlItems, setStateRunGetListAPICall, employeeBasedProvinceOfEmployementDDL }) => {
	return (
		<Grid
			container
			size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			sx={{
				background: "#fff",
				border: "1px solid #e5e7eb",
				borderRadius: "2px",
				padding: "15px",
			}}
			columnSpacing={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
		>
			<Grid size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }} sx={{ mt: "12px" }}>
				<EnhancedDropDownRHFWithLabel
					selectName={"status"}
					items={[
						{ label: "All", value: "all" },
						{ label: "Active", value: 100 },
						{ label: "Died", value: 200 },
						{ label: "Inactive", value: 300 },
						{ label: "Rehired", value: 400 },
						{ label: "Terminated", value: 500 },
					]}
					label={"Status"}
					testId={"status-check"}
					selectedItem={"all"}
					onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				/>
			</Grid>
			<Grid size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }} sx={{ mt: "12px" }}>
				<EnhancedDropDownRHFWithLabel
					label="Payroll Schedule"
					selectName="payFrequency"
					items={employeeReportSetupDDlItems ?? []}
					selectedItem={"all"}
					testId="pay-frequency"
					onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				/>
			</Grid>
			<Grid size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }} sx={{ mt: "12px" }}>
				<EnhancedDropDownRHFWithLabel
					selectName="payMethod"
					label="Pay Method"
					testId={`Pay-Method-list`}
					items={[
						{ label: "All", value: "all" },
						// { label: "Cash", value: 100 },
						{ label: "Cheque", value: 200 },
						{ label: "Direct Deposit", value: 300 },

					]}

					selectedItem={"all"}
					labelColumns={4}
					fieldColumns={8}
					onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				/>
			</Grid>
			<Grid size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }} sx={{ mt: "12px" }}>
				<EnhancedDropDownRHFWithLabel
					selectName={"ProvinceOfEmployment"}
					items={employeeBasedProvinceOfEmployementDDL ?? []}
					label={"Province of Employment"}
					testId={"Province-Of-Employment"}
					selectedItem={"all"}
					onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				/>
			</Grid>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<EnhancedButtonPrimeReact
					label="Apply"
					raised
					type="submit"
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</Grid>
		</Grid>
	);
};
